import { axiosInstance } from '../axiosInstance';
import { IShop } from '../../types/shop';

export const getShops = async (): Promise<IShop[]> => {
  const response = await axiosInstance.get(`/view/shops/all`);
  return response.data;
};
